var _a;
import { Priority as ServerPriority } from '@api-gen';
import { createDataRecordConverter } from '@core/utils/helpers';
import { Priority as ClientPriority } from '@features/guidbooks/types';
export var priorityMap = createDataRecordConverter((_a = {},
    _a[ClientPriority.Zero] = ServerPriority.Zero,
    _a[ClientPriority.One] = ServerPriority.One,
    _a[ClientPriority.Two] = ServerPriority.Two,
    _a[ClientPriority.Three] = ServerPriority.Three,
    _a[ClientPriority.Four] = ServerPriority.Four,
    _a[ClientPriority.Five] = ServerPriority.Five,
    _a[ClientPriority.Six] = ServerPriority.Six,
    _a[ClientPriority.Seven] = ServerPriority.Seven,
    _a[ClientPriority.Eight] = ServerPriority.Eight,
    _a[ClientPriority.Nine] = ServerPriority.Nine,
    _a[ClientPriority.Ten] = ServerPriority.Ten,
    _a));
export var convertToServerPriorityData = function (type) {
    return priorityMap.toServer[type];
};
export var convertToClientPriorityData = function (type) {
    return priorityMap.toClient[type];
};
